<small class="debug">{{me}}</small>
<mat-form-field class="form-element filterList">
  <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
  <input inputrestriction="basic1" matInput type="text" (keyup)="applyFilter($event.target['value'])" name="SearchDualList" class="form-control"
    [(ngModel)]="filter" autocomplete="off"/>
    <a matSuffix aria-label="Clear" (click)="clearSelection()">
      <mat-icon>close</mat-icon>
    </a>
  </mat-form-field>
  <div fxLayout="row wrap" fxLayoutGap="32px" fxLayoutAlign="flex-start" class="flex-lt-md-center-center flex-xs-col">
    @for (res of m_sharedResources; track res) {
      <mat-card appearance="outlined" class="thumbs" [ngStyle]="{'display': res.show ? 'block' : 'none', 'opacity': res.imported ? '0.4' : '1'}" (click)="openImportDialog(res)">
        <mat-card-title style="padding: 3px; padding-bottom: 7px; margin: 0; word-break: break-all;" class="d-flex flex-gt-xs-row flex-xs-col">
          <mat-label style="font-size: 0.8rem; margin-top: auto; margin-bottom: auto;">{{res.name}}</mat-label>
        </mat-card-title>
        <div class="image-wrapper">
          @switch (res.type) {
            @case ('image') {
              <div>
                <img loading="lazy" [src]="res.url" mat-card-image/>
              </div>
            }
            @case ('video') {
              <div>
                @if (ready) {
                  <vg-player>
                    <vg-controls>
                      <vg-play-pause></vg-play-pause>
                      <vg-playback-button></vg-playback-button>
                      <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
                      <vg-scrub-bar>
                        <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                        <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                      </vg-scrub-bar>
                      <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                      <vg-mute></vg-mute>
                      <vg-volume></vg-volume>
                      <vg-fullscreen></vg-fullscreen>
                    </vg-controls>
                    <video id="singleVideo" [vgMedia]="$any(media)" #media [autoplay]="false" preload="auto">
                      <source src="{{res.videoUrl}}" type="video/mp4">
                    </video>
                  </vg-player>
                }
              </div>
            }
            @case ('flash') {
              <div>
                <img loading="lazy" [src]="res.videoUrl" mat-card-image/>
              </div>
            }
            @case ('svg') {
              <div>
                <img loading="lazy" mat-card-image [src]="res.url"/>
                <!--              <svg loading="lazy" sourc src="res.url" mat-card-image/>-->
                <!--              <app-svg-icon mat-card-image style="padding-left: 25px" [height]="'300'" [width]="'240'" [path]="res.url"></app-svg-icon>-->
              </div>
            }
          }
        </div>
        <!-- <img loading="lazy" mat-card-image [src]="res.url"> -->
      </mat-card>
    }
  </div>
  <ng-template let-modal #helperModal>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
      {{'general.importNewResource' | transloco}}
      <div class="dlg-drag-handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
          <path
          d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </div>
    </h1>
    <div mat-dialog-content>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
        <mat-form-field>
          <mat-label>{{'general.name' | transloco}}</mat-label>
          <input [disableControl]="{mode: true, timeoutToEnable: 200}" inputrestriction="basic1" matInput type="text" placeholder="" [(ngModel)]="selectedResource.name">
        </mat-form-field>
        <mat-label>{{'general.category' | transloco}}: {{selectedResource.treePath}}</mat-label>
        <mat-label>{{'general.format' | transloco}}: {{selectedResource.resourceType}}</mat-label>
      </div>
      <br/>
      @if (selectedResource.resourceType === 'mp4') {
        <div>
          <vg-player style="max-height: 300px;">
            <vg-controls>
              <vg-play-pause></vg-play-pause>
              <vg-playback-button></vg-playback-button>
              <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
              <vg-scrub-bar>
                <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
              </vg-scrub-bar>
              <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
              <vg-mute></vg-mute>
              <vg-volume></vg-volume>
              <vg-fullscreen></vg-fullscreen>
            </vg-controls>
            <video [vgMedia]="$any(media)" #media [autoplay]="false" preload="auto">
              <source src="{{selectedResource.videoUrl}}" type="video/mp4">
            </video>
          </vg-player>
        </div>
      }
      @if (selectedResource.resourceType !== 'mp4') {
        <div>
          @if (imageLoading) {
            <div style="height: 250px; padding-top: 100px;">
              <app-loading [type]="-1" [size]="'60px'"></app-loading>
            </div>
          }
          <div [hidden]="imageLoading">
            <img class="image-preview" (load)="onLoad($event)" width="100%" loading="lazy" src="{{selectedResource.url}}"/>
          </div>
        </div>
      }
      <br/>
      <div fxFlex fxLayoutAlign="center center" fxLayoutGap="32px">
        <button mat-raised-button color="warn" (click)="onImportClick()">
          <mat-icon>downloading</mat-icon>
          {{'general.import' | transloco}}
        </button>
        <button mat-raised-button color="primary" (click)="onClose()">{{'general.cancel' | transloco}}</button>
      </div>
    </div>
  </ng-template>
